import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { Transaction, DataList } from '@shared/models';

import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class TransactionService {
  constructor(private apiService: ApiService) {}

  list(): Observable<DataList<Transaction>> {
    return this.apiService.get<DataList<Transaction>>('user/transactions?card_id&date&from&to').pipe();
  }
}
